
class NgMenue {
  constructor(selector, resizer) {
    this.selector = selector;
    this.resizer = resizer;

    this.class = {
      start: 'ng-start',
      preview: 'ng-prev',
      active: 'ng-active',
      breadcrumb: 'ng-bc',
      handler: 'ng-handler',
      icon: 'ng-icon'
    }

    this.elements = {
      submenuDiv: this.selector.querySelectorAll('li.submenu'),
      submenuItem: this.selector.querySelectorAll('.submenu > a, .submenu > strong')
    }

    this.init();
  }

  setBreadcrumb() {
    this.elements.submenuItem.forEach((level) => {
      const title = level.querySelector('span.title').textContent;
      const element = document.createElement('li');
      element.classList.add(this.class.breadcrumb);
      element.innerHTML = title + '<i class="material-icons">arrow_backward<i>';

      level.parentElement.querySelector(':scope > [class*=level_]').prepend(element);
    });
  }

  setSubmenuIcon() {
    this.elements.submenuDiv.forEach((submenu) => {
      const handlerElement = document.createElement('span');
      handlerElement.classList.add(this.class.icon, this.class.handler);
      handlerElement.innerHTML = '<i class="material-icons">arrow_forward<i>';

      submenu.appendChild(handlerElement);
    });
  }

  setSubmenuIconTrigger() {
    const submenuTrigger = this.selector.querySelectorAll('.' + this.class.handler);
    submenuTrigger.forEach((item) => {
      this.levelHandler(item);
    });
  }

  levelHandler(trigger) {
    if(!trigger) {
      return;
    }

    const parentPrev = trigger.parentElement.parentElement;
    const activeLevel = trigger.previousElementSibling;

    trigger.addEventListener('click', () => {
      parentPrev.classList.add(this.class.preview);
      activeLevel.classList.add(this.class.active);
    });

    const activeLevelBreadcrumb = activeLevel.querySelector('.' + this.class.breadcrumb);

    activeLevelBreadcrumb.addEventListener('click', () => {
      parentPrev.classList.remove(this.class.preview);
      activeLevel.classList.remove(this.class.active);
    });
  }

  removeHandler() {
    const previews = this.selector.querySelectorAll('.' + this.class.preview);
    const actives = this.selector.querySelectorAll('.' + this.class.active);
    const breadcrumb = this.selector.querySelectorAll('.' + this.class.breadcrumb);
    const handler = this.selector.querySelectorAll('.' + this.class.handler);

    previews.forEach((item) => {
      item.classList.remove(this.class.preview);
    });
    actives.forEach((item) => {
      item.classList.remove(this.class.active);
    });
    breadcrumb.forEach((item) => {
      item.remove();
    });
    handler.forEach((item) => {
      item.remove();
    });
  }

  init() {
    if(this.selector) {
      window.addEventListener('resize', () => {
        if (document.body.offsetWidth >= this.resizer) {
          this.selector.classList.remove(this.class.start);
          this.removeHandler();
        } else {
          this.selector.classList.add(this.class.start);
          this.selector.style.marginTop = document.querySelector('header').offsetHeight + 'px';
          this.setBreadcrumb();
          this.setSubmenuIcon();
          this.setSubmenuIconTrigger();
        }
      });
    }
  }

}

export default NgMenue;
